import { AnyAction, Reducer } from 'redux';
import {
  SAVE_TRADING_PACK_REQUEST,
  SAVE_TRADING_PACK_RESPONSE,
  SAVE_TRADING_PACK_ERROR,
} from '../../actions/Products';
import { IApiRequest } from '../../types';

const initialState: IApiRequest<string[]> = {
  data: [],
  error: '',
  UpdatedAt: null,
  loading: false,
};

const savePackReducer: Reducer<IApiRequest<string[]>> = (
  state: IApiRequest<string[]> = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SAVE_TRADING_PACK_REQUEST: {
      return {
        ...initialState,
        loading: true,
      };
    }
    case SAVE_TRADING_PACK_RESPONSE: {
      return {
        data: action.response,
        error: '',
        UpdatedAt: new Date(),
        loading: false,
      };
    }
    case SAVE_TRADING_PACK_ERROR: {
      return {
        ...initialState,
        error: 'An error has occured',
      };
    }
    default: {
      return state;
    }
  }
};

export default savePackReducer;
